import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircleRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M26.4 16c0-5.745-4.655-10.4-10.4-10.4S5.6 10.255 5.6 16 10.255 26.4 16 26.4 26.4 21.745 26.4 16M3.2 16C3.2 8.93 8.93 3.2 16 3.2S28.8 8.93 28.8 16 23.07 28.8 16 28.8 3.2 23.07 3.2 16" })
});
export default SvgCheckCircleRegularIcon;
